import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { CommentClassificationReferenceModel } from "../../models/reference-model/reference-general-model";

@Injectable({
    providedIn: 'root'
})
export class CommentClassificationReferenceService extends ApiServiceBase {
    private readonly PATH = "/system/CommentClassificationReferences"

    constructor(httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getCommentClassificationReferences(): Observable<CommentClassificationReferenceModel[]> {
        return this.httpGet<CommentClassificationReferenceModel[]>(this.PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
}